import React, { useContext } from "react";
import setupAccount from "../../img/SetupAccount.jpg";
import { Container, Title, Checklist, Button, StyledDoThisLater } from "./setup.style";
import ListItem from "./ListItem";
import FixelDataContext from "../../context/FixelDataContext";
import { useHistory } from "react-router-dom";
import Tooltip from "../utils/Tooltip";

const FBTooltipContent = "Fixel integrates out of the box with Facebook Ads. This advanced integration will also automate audience management.";
const GATooltipContent = "Fixel integrates out of the box with Google Ads. This advanced integration will also automate audience management.";

const Setup = () => {
  const history = useHistory();
  const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);

  // TODO check if user has assigned platform to be tracked
  const didConnectToPlatforms = () => {
    return true;
  };

  const onSubmit = () => {
    history.go(0);
  }

  return (
    <Container>
      <img src={setupAccount} alt="setupAccount" />
      <Title>Let’s Get You Started</Title>
      <Checklist>
        <li>
          <ListItem label="Install the Fixel app" checked={true} />
          <Button type="button" checked={true} disabled={true}>
            Installed
          </Button>
        </li>
        <li>
          <ListItem label="Connect with ad platforms" checked={didConnectToPlatforms()} />
          <Button type="button" onClick={() => history.push("/setup/connectPlatforms")}>
            {didConnectToPlatforms() ? "Edit" : "Connect"}
          </Button>
        </li>
        {/* <li> */}
        {/* disabled while FB not approved */}
        {/* <ListItem label="Integrate with Facebook" checked={fullFixelData.FBIntegrationStatus === "connected"} />
          <Button type="button" disabled={fullFixelData.FBIntegrationStatus === "connected"} onClick={()=>history.push("/setup/facebook")}>
            Integrate
          </Button> */}
        {/* <Tooltip content={FBTooltipContent}>
            <ListItem label="Connect with Facebook Ads" checked={false} />
            <Button type="button" disabled={true}>
              Coming Soon
            </Button>
          </Tooltip>
        </li>
        <li>
          <Tooltip content={GATooltipContent}>
            <ListItem label="Connect with Google Ads" checked={false} />
            <Button type="button" disabled={true}>
              Coming Soon
            </Button>
          </Tooltip>
        </li> */}
      </Checklist>
      <StyledDoThisLater onClick={() => onSubmit()}>{didConnectToPlatforms() ? `I’m done` : "I’ll do this later"}</StyledDoThisLater>
    </Container>
  );
};
export default Setup;
